import React from 'react';

import { Button } from '@mui/material';
import clsx from 'clsx';

import type { CloseButtonProperties } from './CloseButton.types';

export const CloseButton: React.FC<CloseButtonProperties> = ({
  onClick,
  dataTest = 'close_button',
  color,
  className,
  disabled,
  label = 'Закрыть',
}) => {
  const closeButtonClasses = clsx('m-1', 'ms-0', className);
  const handleClick = React.useCallback(() => {
    onClick?.();
  }, [onClick]);
  return (
    <Button
      data-testid={dataTest}
      id={dataTest}
      onClick={handleClick}
      className={closeButtonClasses}
      color={color}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};
